import { Component, Input, OnInit, inject } from '@angular/core';

import { FormsModule } from '@angular/forms';
import {
  dialogData as projectDialogData,
  genericDialogComponent,
} from '../genericDialog';
import { Customer, Project } from 'TimelogDataTypes';
import { User } from 'BaseDataTypes';
import { ProjectService } from 'TimelogServices/project-service';
import { UserService } from 'BaseServices/user-service';
import { CustomerService } from 'TimelogServices/customer-service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import {
  MatDialogModule,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { dialogInputTitleComponent } from '../../../../../../src/app/elements/dialog-input-title.component';
import { SaveButtonComponent } from '../../../../../../src/app/buttons/save-button/save-button.component';
import { DeleteButtonComponent } from '../../../../../../src/app/buttons/delete-button/delete-button.component';

@Component({
    selector: 'app-project-dialog',
    imports: [
    FormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    dialogInputTitleComponent,
    SaveButtonComponent,
    DeleteButtonComponent,
    MatIconModule
],
    templateUrl: './project-dialog.component.html',
    styleUrl: './project-dialog.component.css'
})
export class ProjectDialogComponent
  extends genericDialogComponent
  implements OnInit
{
  readonly data = inject<projectDialogData<Project[]>>(MAT_DIALOG_DATA);
  @Input() projectData!: Project;
  @Input() customers!: Customer[];
  @Input() users!: User[];
  currentUser = this.userService.currentUser;
  dialogInputTitleComponent = dialogInputTitleComponent;

  constructor(
    public override dialogRef: MatDialogRef<ProjectDialogComponent>,
    private projectService: ProjectService,
    private customerService: CustomerService,
    public userService: UserService
  ) {
    super(dialogRef);
    this.projectData = this.data.data[0];
  }

  ngOnInit(): void {
    this.customerService.getCustomers().subscribe((result) => {
      this.customers = result;
    });
    this.userService.getUsers().subscribe((result) => {
      this.users = result;
    });
  }

  clearDate(event: MouseEvent) {
    event.stopPropagation(); // Prevents opening the picker when clearing
    this.projectData.closedDate = null;
  }


  saveChanges() {
    this.projectService.updateProject(this.projectData).subscribe(
      (result) => {
        this.dialogRef.close(true);
      },
      (error) => console.log(error)
    );
  }

  deleteProject() {
    if (
      !confirm(
        'Er du sikker på at du vil slette projektet ' +
          this.projectData.name +
          '?'
      )
    ) {
      return;
    }
    this.projectService
      .deleteProject(this.projectData.id)
      .subscribe((result) => {
        this.dialogRef.close(true);
      });
  }
}
